<script setup lang="ts">
export interface BreadcrumbsProps {
    links: BreadcrumbsLink[];
    current: string;
}
const props = defineProps<BreadcrumbsProps>()
const { $t } = useNuxtApp()
const title = $t('Úvod')
</script>
<template>
  <nav
    class="breadcrumbs position-relative my-3 overflow-auto"
    :aria-label="$t('Omrvinková navigácia')"
  >
    <Tracker :data="{ position: 'Page', title: 'Breadcrumb' }">
      <ul class="gap-2 d-flex fs-xsmall">
        <li class="breadcrumbs-item ms-1">
          <VNuxtLink
            class="breadcrumbs-link d-flex align-items-center my-1"
            :to="{ name: 'home' }"
            :label="title"
          >
            {{ title }}
          </VNuxtLink>
        </li>

        <BreadcrumbsItem
          v-for="(link, index) in props.links"
          :key="`breadcrumb-item-${index}`"
        >
          <VNuxtLink
            class="breadcrumbs-link my-1"
            :to="link.slug"
            :label="link.name"
          >
            {{ link.name }}
          </VNuxtLink>
        </BreadcrumbsItem>

        <BreadcrumbsItem>
          <span tabindex="0">
            {{ props.current }}
            <span class="visually-hidden">
              , {{ $t('aktuálna stránka') }}
            </span>
          </span>
        </BreadcrumbsItem>
      </ul>
    </Tracker>
  </nav>
</template>

<style>
@import "./Breadcrumbs.vars.scss";
</style>

<style scoped lang="scss">
@import "./Breadcrumbs.scss";
</style>
